
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.78 8.435a.317.317 0 10-.634 0c0 .885.784 1.618 1.802 1.746v1.355a.317.317 0 10.634 0v-1.355c1.017-.13 1.8-.862 1.8-1.746 0-.883-.783-1.614-1.8-1.744V4.432c.665.111 1.165.565 1.165 1.106a.317.317 0 10.634 0c0-.884-.782-1.617-1.799-1.745V2.436a.317.317 0 10-.634 0v1.357c-1.018.128-1.802.86-1.802 1.745 0 .883.784 1.616 1.802 1.743v2.261c-.667-.11-1.167-.565-1.167-1.107zm2.967 0c0 .541-.5.994-1.165 1.106v-2.21c.665.111 1.165.564 1.165 1.104zM3.78 5.538c0-.541.5-.995 1.167-1.106v2.21C4.28 6.532 3.78 6.08 3.78 5.538z","fill":"#fff"}}),_c('path',{attrs:{"d":"M21.681.783H1.275a.316.316 0 00-.318.313v12.765c0 .173.142.313.318.313h20.406c.176 0 .319-.14.319-.313V1.096a.316.316 0 00-.319-.313zm-.319 12.764H1.595V1.41h19.768v12.138z","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.995 4.786h9.232a.317.317 0 100-.634H9.995a.317.317 0 100 .634zM9.995 7.932h9.232a.317.317 0 100-.635H9.995a.317.317 0 100 .635zM9.995 10.95h9.232a.317.317 0 100-.635H9.995a.317.317 0 100 .635z","fill":"#fff"}})])
          )
        }
      }
    